import './index.css';

export const ProfileIconSvg = () => (
  <svg
    className='profile-icon-svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.7515 6.67749C15.7515 9.07493 13.7887 10.9275 12.0015 10.9275C10.2142 10.9275 8.25146 9.07493 8.25146 6.67749C8.25146 4.254 10.0028 2.42749 12.0015 2.42749C14.0002 2.42749 15.7515 4.254 15.7515 6.67749Z'
      strokeWidth='1.5'
    />
    <mask id='path-2-inside-1_19105_34953' fill='white'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.5015 17.6882C21.5015 21.9709 16.7515 22 12.0015 22C7.25146 22 2.50146 21.9709 2.50146 17.6882C2.50146 15.2409 6.75476 13 12.0015 13C17.2482 13 21.5015 15.2409 21.5015 17.6882Z'
      />
    </mask>
    <path
      d='M20.0015 17.6882C20.0015 18.4624 19.7955 18.9021 19.5471 19.1914C19.276 19.5071 18.8241 19.7933 18.0956 20.0152C16.5737 20.4788 14.4502 20.5 12.0015 20.5V23.5C14.3027 23.5 16.9292 23.5066 18.9698 22.885C20.0226 22.5643 21.0551 22.0402 21.823 21.1459C22.6137 20.2253 23.0015 19.0553 23.0015 17.6882H20.0015ZM12.0015 20.5C9.55272 20.5 7.42925 20.4788 5.90732 20.0152C5.1788 19.7933 4.72695 19.5071 4.45585 19.1914C4.20741 18.9021 4.00146 18.4624 4.00146 17.6882H1.00146C1.00146 19.0553 1.38927 20.2253 2.17989 21.1459C2.94786 22.0402 3.98038 22.5643 5.03311 22.885C7.07368 23.5066 9.70021 23.5 12.0015 23.5V20.5ZM4.00146 17.6882C4.00146 17.3607 4.36152 16.5707 5.95885 15.766C7.43647 15.0215 9.57359 14.5 12.0015 14.5V11.5C9.18263 11.5 6.56975 12.0989 4.60904 13.0868C2.76805 14.0143 1.00146 15.5684 1.00146 17.6882H4.00146ZM12.0015 14.5C14.4294 14.5 16.5665 15.0215 18.0441 15.766C19.6414 16.5707 20.0015 17.3607 20.0015 17.6882H23.0015C23.0015 15.5684 21.2349 14.0143 19.3939 13.0868C17.4332 12.0989 14.8203 11.5 12.0015 11.5V14.5Z'
      strokeWidth='10'
      mask='url(#path-2-inside-1_19105_34953)'
    />
  </svg>
);
